import { gql } from '@apollo/client';

export const CREDENTIAL = gql`
  fragment Credential on Credential {
    id
    source
    name
    address
    startDate
    endDate
    filterSpam
    txnCount
    credentialType
    integrationName
    latestTransaction
    earliestTransaction
    createdAt
    updatedAt
    status
    lastRefreshError
    errorRemediation
    errorType
    requiresCredentialUpdate
    integrationId
    isOauth
    reconcileOnSync
    accountId
    ensAlias
    otherIntegration
    variousIntegrations
    account {
      id
      name
    }
  }
`;
